__turbopack_context__.v({
  "downloadUrlWidget": "DownloadUrlWidget-module-scss-module__LzO5Vq__downloadUrlWidget",
});
